__turbopack_context__.v({
  "item": "_1LToDa_item",
  "menuContent": "_1LToDa_menuContent",
  "trigger": "_1LToDa_trigger",
});
